export function accessibility() {
	function keyboardHandler(e, firstFocus, lastFocus) {
		if (e.keyCode === 9) {
			//Rotate Focus
			if (e.shiftKey && document.activeElement === firstFocus) {
				e.preventDefault()
				firstFocus.focus()
			} else if (!e.shiftKey && document.activeElement === lastFocus) {
				e.preventDefault()
				firstFocus.focus()
			}
		}
	}

	// navigation tabindex catcher
	const navigation = document.querySelector('.site__navigation')
	const site_header = document.querySelector('.site__header')
	if (navigation && site_header) {
		const navigationLinks = navigation.querySelectorAll('a:not([tabindex="-1"], [type="hidden"])')
		const navigationFirst = site_header.querySelector('a:not([tabindex="-1"], [type="hidden"])')
		const navigationLast = navigationLinks[navigationLinks.length - 1]

		navigation.addEventListener('keydown', (e) => {
			keyboardHandler(e, navigationFirst, navigationLast)
		})
		site_header.addEventListener('keydown', (e) => {
			keyboardHandler(e, navigationFirst, navigationLast)
		})
	}

	// dialog tabindex catcher
	const dialogs = document.querySelectorAll('dialog')

	if (dialogs) {
		dialogs.forEach((dialog) => {
			const dialogLinks = dialog.querySelectorAll(':is(a, button, input, select, textarea):not([tabindex="-1"], [type="hidden"])')
			const dialogFirst = dialogLinks[0]
			const dialogLast = dialogLinks[dialogLinks.length - 1]

			dialog.addEventListener('keydown', (e) => {
				keyboardHandler(e, dialogFirst, dialogLast)
			})
		})
	}

	// mobile filter tabindex catcher
	const listingFilter = document.querySelector('#listing__filter')
	const filterIcon = document.querySelector('#filter-icon')

	if (listingFilter && filterIcon) {
		const listingFilterLinks = listingFilter.querySelectorAll(':is(a, button, input, select, textarea):not([tabindex="-1"], [type="hidden"])')
		const listingFilterFirst = filterIcon
		const listingFilterLast = listingFilterLinks[listingFilterLinks.length - 1]

		listingFilter.addEventListener('keydown', (e) => {
			keyboardHandler(e, listingFilterFirst, listingFilterLast)
		})

		filterIcon.addEventListener('keydown', (e) => {
			keyboardHandler(e, listingFilterFirst, listingFilterLast)
		})
	}
}
